import { forgotPassword } from './pages/forgotPassword';
import { geolocationDenied } from './pages/geolocationDenied';
import { login } from './pages/login';
import { validateToken } from './pages/validateToken';

export const pt = {
  pages: {
    login,
    forgotPassword,
    geolocationDenied,
    validateToken,
  },
  components: {
    languageSwitch: {
      label: 'Alterar idioma',
      pt: 'Português',
      en: 'Inglês',
      es: 'Espanhol',
    },
    servicesSelection: {
      title: 'Selecionar serviços',
      selectAtLeastOne: 'Selecione pelo menos um serviço',
      next: 'Próximo',
    },
    additionalFields: {
      title: 'Campos Adicionais',
      back: 'voltar',
      zipLabel: 'CEP',
      phoneLabel: 'Telefone',
      emailLabel: 'E-mail',
      next: 'Próximo',
      zipRequired: 'CEP é obrigatório!',
      phoneRequired: 'Telefone é obrigatório!',
      emailRequired: 'E-mail é obrigatório!',
    },
    bodyStep: {
      identificationBy: 'Identificação por {{validation}}',
      companyLabel: 'Empresa:',
      userLabel: 'Usuário:',
      signOut: 'Sair',
      versionLabel: 'Versão:',
      apiVersionLabel: 'Versão API:',
    },
    camera: {
      title: 'Foto',
      back: 'voltar',
      clear: 'LIMPAR',
      next: 'PRÓXIMO',
      uploadImage: 'UPLOAD DE IMAGEM',
      camera: 'CÂMERA',
      takePhoto: 'TIRAR FOTO',
    },
    choose: {
      title: 'Selecionar método de análise',
      back: 'voltar',
      cnhOption: 'Análise da CNH/Passaporte',
      faceOption: 'Análise por foto da face',
    },
    identification: {
      title: 'Dados Pessoais',
      back: 'voltar',
      nameLabel: 'Nome Completo',
      birthLabel: 'Data de nascimento',
      documentTypeLabel: 'Tipo do documento',
      documentNumberLabel: 'Número',
      next: 'Próximo',
      nameRequired: 'Nome é obrigatório!',
      birthRequired: 'Data de nascimento é obrigatório!',
      documentInvalid: 'Documento inválido',
    },
    instructions: {
      title: 'Instruções',
      back: 'voltar',
      next: 'Próximo',
      selfie: {
        faceVisible: 'Tire uma selfie com o rosto frontal e visível',
        goodLighting: 'Busque uma boa iluminação',
        removeAccessories: 'Remova adereços como óculos e chapéu',
        avoidRotation: 'Evite rotacionar a câmera do dispositivo',
      },
      document: {
        flatSurface: 'Apoie o documento em uma superfície plana',
        goodLighting: 'Busque uma boa iluminação',
        adjustFocus: 'Ajuste o foco para garantir a qualidade',
        avoidRotation: 'Evite rotacionar a câmera do dispositivo',
      },
    },
    result: {
      title: 'Resultado',
      fullName: 'Nome Completo',
      document: 'Documento',
      status: {
        recommended: 'SEM APONTAMENTOS',
        notRecommended: 'COM APONTAMENTOS',
        failed: 'FALHA',
      },
      buttons: {
        returnToPlatform: 'Voltar à plataforma SGRLOC',
        takeAnotherPhoto: 'Tirar nova foto',
        backToStart: 'Voltar ao Início',
      },
    },
    optIn: {
      title: 'Termos de Uso',
      checkboxText: 'Eu li e concordo com estes termos e condições',
      buttons: {
        accept: 'Aceitar',
        refuse: 'Recusar',
      },
    },
    faceTecCamera: {
      back: 'voltar',
      titleCaptured: 'Foto capturada',
      titleDefault: 'Foto',
      buttons: {
        clear: 'LIMPAR',
        next: 'PRÓXIMO',
        startCamera: 'INICIAR CÂMERA',
      },
      loadingCapture: 'Carregando a captura',
      capturedAlt: 'Foto capturada',
    },
    loading: {
      alt: 'Carregando...',
    },
    dropzone: {
      documentAlt: 'Imagem do documento',
      placeholder: 'Selecione seu documento',
      fileTooLarge: 'Tamanho máximo da imagem deve ser de 1Mb',
    },
    logos: {
      sgrLoc: 'Logo SGRLoc',
      swint: 'Logo Odeen',
    },
  },
};

export default pt;
